import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { Billing } from 'markets-lib';

import { config } from '../config';
import { prepHeaders } from '../util';

interface ExtraParameters {
  contractId: string;
}

export const billingsApi = createApi({
  reducerPath: 'billings',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: prepHeaders,
  }),
  tagTypes: ['Billings'],
  endpoints: (builder) => ({
    upsert: builder.mutation<Billing & ExtraParameters, Billing>({
      query: (payload) => ({
        url: '/api/billings',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Billings'],
    }),
    getAll: builder.query<Billing[], void>({
      query: () => '/api/billings',
      providesTags: ['Billings'],
    }),
    getById: builder.query<Billing, Billing['id']>({
      query: (id) => `/api/billings/${id}`,
      providesTags: ['Billings'],
    }),
    remove: builder.mutation<Billing[], Billing['id']>({
      query: (id) => ({
        url: `/api/billings/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Billings'],
    }),
  }),
});

export const {
  endpoints,
  middleware,
  reducer,
  reducerPath,
  useUpsertMutation,
  useRemoveMutation,
  useGetAllQuery,
  useGetByIdQuery,
} = billingsApi;
